import { config } from "@/config";
const getHeaders = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
});
export const PermissionService = {
    getRoles: async () => {
        const res = await fetch(`${config.API_URL}/api/Permission/roles`, {
            headers: getHeaders(),
        });
        return await res.json();
    },
    getAllPermissions: async () => {
        const res = await fetch(`${config.API_URL}/api/Permission/available`, {
            headers: getHeaders(),
        });
        return await res.json();
    },
    updateRolPermissions: async (rolId, permisoIds) => {
        const res = await fetch(`${config.API_URL}/api/Permission/roles/${rolId}/sync`, {
            method: "POST",
            headers: getHeaders(),
            body: JSON.stringify({ permisoIds }),
        });
        return await res.json();
    },
    seedPermissions: async () => {
        const res = await fetch(`${config.API_URL}/api/Permission/seed`, {
            method: "POST",
            headers: getHeaders(),
        });
        return await res.json();
    },
    createRol: async (nombre) => {
        const res = await fetch(`${config.API_URL}/api/Permission/roles`, {
            method: "POST",
            headers: getHeaders(),
            body: JSON.stringify({ nombre }),
        });
        return await res.json();
    },
    updateRol: async (rolId, nombre) => {
        const res = await fetch(`${config.API_URL}/api/Permission/roles/${rolId}`, {
            method: "PUT",
            headers: getHeaders(),
            body: JSON.stringify({ nombre }),
        });
        return await res.json();
    },
    deleteRol: async (rolId) => {
        const res = await fetch(`${config.API_URL}/api/Permission/roles/${rolId}`, {
            method: "DELETE",
            headers: getHeaders(),
        });
        return await res.json();
    },
};
